import { render, staticRenderFns } from "./UsersDeleteDataRequestsHistoryTable.vue?vue&type=template&id=6a58794d&scoped=true"
import script from "./UsersDeleteDataRequestsHistoryTable.vue?vue&type=script&lang=js"
export * from "./UsersDeleteDataRequestsHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./UsersDeleteDataRequestsHistoryTable.vue?vue&type=style&index=0&id=6a58794d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a58794d",
  null
  
)

export default component.exports